import useLanguage from "hooks/language";
import React from "react";
import { getPreSelectedLabType } from "utils/session-storage";
import { BookingFlowStepId, getBookingFlowStepOrder } from "./types";
import styles from "./booking-flow-step-nav.module.css";

type BookingFlowStepNavProps = {
    currentStep: BookingFlowStepId;
    /** When set, overrides session (e.g. lab page before submit). */
    skipConsultationStep?: boolean;
};

const BookingFlowStepNav: React.FunctionComponent<BookingFlowStepNavProps> = ({
    currentStep,
    skipConsultationStep,
}) => {
    const { translations } = useLanguage();
    const stepLabels = translations.bookingFlow.steps;
    const hideConsultation = skipConsultationStep ?? getPreSelectedLabType();
    const visibleSteps = getBookingFlowStepOrder(hideConsultation);

    return (
        <ol
            className={styles.stepNav}
            aria-label={translations.bookingFlow.stepNavAriaLabel}
        >
            {visibleSteps.map((stepId, index) => {
                const isActive = stepId === currentStep;
                const label = stepLabels[stepId];
                return (
                    <li
                        key={stepId}
                        className={`${styles.stepNavItem} ${
                            isActive ? styles.stepNavItemActive : ""
                        }`}
                        aria-current={isActive ? "step" : undefined}
                    >
                        {index > 0 && (
                            <span
                                className={styles.separator}
                                aria-hidden="true"
                            >
                                ·
                            </span>
                        )}
                        <span>{label}</span>
                    </li>
                );
            })}
        </ol>
    );
};

export default BookingFlowStepNav;
